import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import classes from "./footerSeo.module.scss";

const FooterSeo = () => {
  const footerData = window.footerSeo || {};
  const seoSections = footerData.seoSections || [];
  const whySunnyDiamonds = footerData.whySunnyDiamonds || [];
  const popularCollections = footerData.popularCollections || [];
  const [expanded, setExpanded] = useState(false);
  const toggleButtonRef = useRef(null);

  const handleToggle = () => {
    const shouldKeepButtonInView =
      expanded && window.matchMedia("(max-width: 575.98px)").matches;

    setExpanded((prev) => !prev);

    if (shouldKeepButtonInView) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (toggleButtonRef.current) {
            toggleButtonRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
      });
    }
  };

  return (
    <section className={classes.footer_seo}>
      <div className="custom-container">
        <div
          className={`${classes.seo_content} ${expanded ? classes.expanded : ""}`}
        >
          {seoSections.map((section, index) => (
            <div key={index} className={classes.seo_block}>
              <h2 className={`${classes.seo_title} uk-padding-remove`}>{section.title}</h2>
              {section.content.map((para, pIndex) => (
                <p key={pIndex} className={classes.seo_text}>
                  {para}
                </p>
              ))}
            </div>
          ))}

          <div className={classes.seo_block}>
            <h2 className={`${classes.seo_title} uk-padding-remove`}>Why Sunny Diamonds?</h2>
            <ul className={classes.seo_list}>
              {whySunnyDiamonds.map((item, index) => (
                <li key={index}>
                  <strong>{item.label}</strong> {item.text}
                </li>
              ))}
            </ul>
            {footerData.whySunnyDiamondsFooter && (
              <p className={classes.seo_text}>
                {footerData.whySunnyDiamondsFooter}
              </p>
            )}
          </div>

          <div className={classes.seo_block}>
            <h2 className={`${classes.seo_title} uk-padding-remove`}>Popular Collections</h2>
            {popularCollections.map((collection, index) => (
              <div key={index} className={classes.collection_group}>
                <h3 className={classes.collection_category}>
                  {collection.categoryLink ? (
                    <Link to={collection.categoryLink} className={classes.collection_link}>
                      {collection.category}
                    </Link>
                  ) : (
                    <span className={classes.collection_link}>{collection.category}</span>
                  )}
                </h3>
                <p className={classes.collection_links}>
                  {collection.links.map((item, lIndex) => {
                    const title = typeof item === "string" ? item : item.title;
                    const url = typeof item === "string" ? null : item.link;
                    return (
                      <React.Fragment key={lIndex}>
                        {lIndex > 0 && (
                          <span className={classes.separator}>|</span>
                        )}
                        {url ? (
                          <Link to={url} className={classes.collection_link}>
                            {title}
                          </Link>
                        ) : (
                          <span className={classes.collection_link}>{title}</span>
                        )}
                      </React.Fragment>
                    );
                  })}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={`${classes.btn_wrap} ${expanded ? classes.read_less : ""}`}>
          <button
            ref={toggleButtonRef}
            className={classes.read_more_btn}
            onClick={handleToggle}
          >
            {expanded ? "Read Less" : "Read More"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default FooterSeo;
